import { MarkdownWithLaTeX } from "@/components/math/MarkdownWithLaTeX";
import SortableTable from "@/components/tables/SortableTable";
import { useMemo } from "react";

export const useProcessElementsForChatRendering = (textParts: any[], tables: any[], markdownComponents: Record<string, any>) =>
    useMemo(() => {
        const elements: React.ReactElement[] = [];
        const allParts = [
            ...textParts.map((part) => ({ ...part, type: "text" as const })),
            ...tables.map((table) => ({ ...table, type: "table" as const })),
        ].sort((a, b) => a.index - b.index);

        allParts.forEach((part, i) => {
            if (part.type === "text") {
                elements.push(
                    <MarkdownWithLaTeX key={`text-${part.index}`} components={markdownComponents as any}>
                        {part.text}
                    </MarkdownWithLaTeX>
                );
            } else {
                elements.push(
                    <SortableTable key={`table-${part.index}`} headers={part.headers} rows={part.rows} tableIndex={i} />
                );
            }
        });

        return elements;
    }, [textParts, tables, markdownComponents]);
